import { GET_EVENTS_START, GET_EVENTS_END } from "./actionTypes";

const INIT_STATE = {
  loading: false,
  events: {},
};

const eventsReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EVENTS_START:
      return {
        ...state,
        loading: true,
        events: {},
      };
    case GET_EVENTS_END:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        events: action.payload.data,
      };
    default:
      return state;
  }
};

export default eventsReducer;
